import { Locale } from 'date-fns';

export type LocalePromise = Promise<{ [key: string]: Locale }>;
export type LocaleDefinition = {
  key?: string;
  fn: () => LocalePromise;
};

export const dateFnsLocales: { [key: string]: LocaleDefinition } = {
  en: {
    key: 'enGB',
    fn: () => import('date-fns/locale/en-GB') as LocalePromise,
  },
  'en-US': {
    key: 'enUS',
    fn: () => import('date-fns/locale/en-US') as LocalePromise,
  },
  'en-GB': {
    key: 'enGB',
    fn: () => import('date-fns/locale/en-GB') as LocalePromise,
  },
  pl: {
    fn: () => import('date-fns/locale/pl') as LocalePromise,
  },
  cs: { // Czech
    fn: () => import('date-fns/locale/cs') as LocalePromise,
  },
  sk: { // Slovak
    fn: () => import('date-fns/locale/sk') as LocalePromise,
  },
  hu: {
    fn: () => import('date-fns/locale/hu') as LocalePromise,
  },
  nb: {
    fn: () => import('date-fns/locale/nb') as LocalePromise,
  },
  nn: {
    fn: () => import('date-fns/locale/nn') as LocalePromise,
  },
  no: {
    fn: () => import('date-fns/locale/nb') as LocalePromise,
  },
  sv: { // Sweden
    fn: () => import('date-fns/locale/sv') as LocalePromise,
  },
  ta: { // Tamil
    fn: () => import('date-fns/locale/ta') as LocalePromise,
  },
  'zn-CN': {
    key: 'znCN',
    fn: () => import('date-fns/locale/zh-CN') as LocalePromise,
  },
  'zn-TW': {
    key: 'zhTW',
    fn: () => import('date-fns/locale/zh-TW') as LocalePromise,
  },
  ms: { // Malay
    fn: () => import('date-fns/locale/ms') as LocalePromise,
  },
  es: {
    fn: () => import('date-fns/locale/es') as LocalePromise,
  },
  ca: {
    fn: () => import('date-fns/locale/ca') as LocalePromise,
  },
  de: {
    fn: () => import('date-fns/locale/de') as LocalePromise,
  },
  fr: {
    fn: () => import('date-fns/locale/fr') as LocalePromise,
  },
  nl: { // Dutch
    fn: () => import('date-fns/locale/nl') as LocalePromise,
  },
  fi: {
    fn: () => import('date-fns/locale/fi') as LocalePromise,
  },
  ro: { // Romanian
    fn: () => import('date-fns/locale/ro') as LocalePromise,
  },
  lt: { // Lithuanian
    fn: () => import('date-fns/locale/lt') as LocalePromise,
  },
  sr: { // Serbian
    fn: () => import('date-fns/locale/sr') as LocalePromise,
  },
  bg: { // Bulgarian
    fn: () => import('date-fns/locale/bg') as LocalePromise,
  },
  hr: { // Croatian
    fn: () => import('date-fns/locale/hr') as LocalePromise,
  },
  sq: { // Albanian
    fn: () => import('date-fns/locale/sq') as LocalePromise,
  },
};
